import { render, staticRenderFns } from "./tabGatheringTrailerBaseUICustomLayout.vue?vue&type=template&id=74c71d1b&"
import script from "./tabGatheringTrailerBaseUICustomLayout.vue?vue&type=script&lang=js&"
export * from "./tabGatheringTrailerBaseUICustomLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74c71d1b')) {
      api.createRecord('74c71d1b', component.options)
    } else {
      api.reload('74c71d1b', component.options)
    }
    module.hot.accept("./tabGatheringTrailerBaseUICustomLayout.vue?vue&type=template&id=74c71d1b&", function () {
      api.rerender('74c71d1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Integrated/components/booking/tabs/tabGatheringTrailerBaseUICustomLayout.vue"
export default component.exports